import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: () => import('@/views/homepage/index'),
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: () => import('@/views/recruit/index'),
    },
    {
      path: '/recruiters',
      name: 'recruiters',
      component: () => import('@/views/recruiters/index'),
    },
    {
      path: '/electronicCommerce',
      name: 'electronicCommerce',
      component: () => import('@/views/electronicCommerce/index'),
    },
    {
      path: '/solarLights',
      name: 'solarLights',
      component: () => import('@/views/solarLights/index'),
    },
    {
      path: '/fmcg',
      name: 'fmcg',
      component: () => import('@/views/fmcg/index'),
    },
    {
      path: '/advancedMaterials',
      name: 'advancedMaterials',
      component: () => import('@/views/advancedMaterials/index'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/index'),
    },
    {
      path: '/connect',
      name: 'connect',
      component: () => import('@/views/connect/index'),
    },
  ],
  mode: 'history',//去除#
})





// WEBPACK FOOTER //
// ./src/router/index.js